module.exports = __webpack_public_path__ + "static/img/6.8ac5330.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/2/5/eng/6.png
// module id = LHhz
// module chunks = 0